import React, { useState, useEffect } from "react";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { useNavigate, useParams } from "react-router-dom";
import { function_ABM_IMP_Terminales_ParaAperturaDeCaja_Generar_JSON, function_ABM_IMP_Terminales_ParaCierreDeCaja_Generar_JSON, function_ABM_IMP_Terminales_Leer, function_ABM_IMP_Terminales_Modificar } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_Terminales";
import { function_CON_OperacionesParaImportar_ParaFaltanteCaja_Generar_JSON, function_CON_OperacionesParaImportar_ParaGasto_Generar_JSON, function_CON_OperacionesParaImportar_ParaSobranteCaja_Generar_JSON, function_CON_OperacionesParaImportar_Insertar } from "neftis7_apicaller/src/funciones/CONT/CON_OperacionesParaImportar";
import ComboAbmEexPersonas from "../../Componentes/Compuestos/Combos/ComboAbmEexPersonas"
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import ComboAbmArtArticulosGastosPV from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulosGastosPV";
import { NumberBox, TextBox } from "devextreme-react";
import { function_CON_Transferencias_Generar_JSON, function_CON_Transferencias_Insertar } from "neftis7_apicaller/src/funciones/CONT/CON_Transferencias";
import { function_ABM_CON_CuentasFinancieras_LeerSaldo } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_CuentasFinancieras";
import { function_VEN_CierresDeCaja_Cabecera_ImpresionComandera, function_VEN_CierresDeCaja_Cabecera_Insertar, function_VEN_CierresDeCaja_Cabecera_PrepararParaCierre } from "neftis7_apicaller/src/funciones/VEN/CierresDeCaja/VEN_CierresDeCaja_Cabecera";
import { FormateoFechaPara_yyyyMMdd, FormateoFechaPara_yyyyMMdd_HHmmss, ObtieneParametros, TratamientoDeVariableBoolean } from "neftis7_apicaller/src/funciones/Varios";
import ComboAbmEexPersonasAutorizantes from "../../Componentes/Compuestos/Combos/ComboAbmEexPersonasAutorizantes";
import { function_ABM_EEX_Personas_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Personas";
import { function_VEN_DocsVenta_Cabecera_ImpresionComandera, function_VEN_DocsVenta_Cabecera_Leer, function_VEN_DocsVenta_Cabecera_ListarPorValidarSinCierreDeCajaPorTerminalSeleccionada } from "neftis7_apicaller/src/funciones/VEN/DocsVenta/VEN_DocsVenta_Cabecera";

export const VEN_PuntoDeVenta_Administracion = () => {
  let { Terminal } = useParams();
  const navigate = useNavigate();

  const [resultTerminal, setResultTerminal] = useState([]);
  const [saldoAperturaEfectivo, setSaldoAperturaEfectivo] = useState(0);
  const [saldoCierreEfectivo, setSaldoCierreEfectivo] = useState(0);
  const [saldoCierreCredito, setSaldoCierreCredito] = useState(0);
  const [saldoCierreDebito, setSaldoCierreDebito] = useState(0);
  const [esApertura, setEsApertura] = useState(false);
  const [passwordApertura, setPasswordApertura] = useState("");
  const [idPersonaResponsable, setIdPersonaResponsable] = useState(0);
  const [idPersonaGastoAutorizante, setIdPersonaGastoAutorizante] = useState(0);
  const [idPersonaRetiroAutorizante, setIdPersonaRetiroAutorizante] = useState(0);
  const [importeGasto, setImporteGasto] = useState(0);
  const [codigoArticuloGasto, setCodigoArticuloGasto] = useState("");
  const [passwordGasto, setPasswordGasto] = useState("");
  const [passwordRetiro, setPasswordRetiro] = useState("");
  const [descripcionGasto, setDescripcionGasto] = useState("");
  const [importeRetiro, setImporteRetiro] = useState(0);
  const [efectivoActual, setEfectivoActual] = useState(0);
  const [avisaFaltanteAlCierre, setAvisaFaltanteAlCierre] = useState(true);
  const [retiroAutomaticoDelTotalAlCierre, setRetiroAutomaticoDelTotalAlCierre] = useState(false);
  const [ventasPVPermiteVisualizarEfectivoDeCaja, setVentasPVPermiteVisualizarEfectivoDeCaja] = useState(false);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);
  const [puedeVerSaldosDeCierre, setPuedeVerSaldosDeCierre] = useState(false);
  const [visualizarWarningDeValidacion, setVisualizarWarningDeValidacion] = useState(false);

  const leerEfectivoActual = async () => {
    if (resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja && resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja !== "") {
      const resultSaldoCuentaFinanciera = await function_ABM_CON_CuentasFinancieras_LeerSaldo(resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja)
      const SaldoCF = resultSaldoCuentaFinanciera.data[0].Saldo
      setEfectivoActual(SaldoCF)
    }
    else {
      setEfectivoActual(0)
    }
  }

  const handleOnClickAceptarApertura = async () => {
    try {
      if (!idPersonaResponsable || idPersonaResponsable < 1) {
        alert("Debe seleccionar una Persona Responsable")
        return
      }

      const resultPersonaResponsable = await function_ABM_EEX_Personas_Leer(idPersonaResponsable)

      if (passwordApertura !== resultPersonaResponsable.data.Password) {
        alert("Contraseña inválida.")
        return
      }

      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      //SOLICITO IMPORTE EFECTIVO
      const saldoCierreAnterior = resultTerminal.data[0].ImporteUltimoSaldoCierreEfectivo

      //CALCULO SOBRANTES Y FALTANTES
      let TerminalImporteFaltanteSaldoAperturaEfectivo = 0
      let TerminalImporteSobranteSaldoAperturaEfectivo = 0
      const TerminalImporteUltimoSaldoAperturaEfectivo = saldoAperturaEfectivo;
      let TerminalUltimoTurnoAbierto = 1;
      const TerminalFechaUltimaCargaSaldoApertura = new Date();

      if (saldoCierreAnterior > saldoAperturaEfectivo) {
        TerminalImporteFaltanteSaldoAperturaEfectivo = saldoCierreAnterior - saldoAperturaEfectivo

        const resultFaltante = await function_CON_OperacionesParaImportar_ParaFaltanteCaja_Generar_JSON(true, TerminalImporteFaltanteSaldoAperturaEfectivo,
          resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja, idPersonaResponsable)

        await function_CON_OperacionesParaImportar_Insertar(resultFaltante)
      }

      if (saldoCierreAnterior < saldoAperturaEfectivo) {
        TerminalImporteSobranteSaldoAperturaEfectivo = saldoAperturaEfectivo - saldoCierreAnterior

        const resultSobrante = await function_CON_OperacionesParaImportar_ParaSobranteCaja_Generar_JSON(true, TerminalImporteSobranteSaldoAperturaEfectivo,
          resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja, idPersonaResponsable)

        await function_CON_OperacionesParaImportar_Insertar(resultSobrante)
      }

      //GUARDO IMPORTE Y FECHA DE APERTURA
      if (new Date(resultTerminal.data[0].FechaUltimaCargaSaldoApertura).getDate() != new Date().getDate()) {
        if (resultTerminal.data[0].HoraDesdeLaCualSalteaPrimerTurno > 0) {
          if (resultTerminal.data[0].HoraDesdeLaCualSalteaPrimerTurno <= new Date().getHours()) {
            TerminalUltimoTurnoAbierto = resultTerminal.data[0].UltimoTurnoAbierto + 1;
          }
        }
      }
      else {
        TerminalUltimoTurnoAbierto = resultTerminal.data[0].UltimoTurnoAbierto + 1;
      }

      const terminalJSON = await function_ABM_IMP_Terminales_ParaAperturaDeCaja_Generar_JSON(Terminal,
        TerminalFechaUltimaCargaSaldoApertura, TerminalImporteUltimoSaldoAperturaEfectivo,
        TerminalImporteFaltanteSaldoAperturaEfectivo, TerminalImporteSobranteSaldoAperturaEfectivo,
        TerminalUltimoTurnoAbierto, idPersonaResponsable)

      console.log(terminalJSON)
      await function_ABM_IMP_Terminales_Modificar(terminalJSON)

      navigate(`/VEN_PuntoDeVenta_`)

    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  const handleOnClickAceptarCierre = async () => {
    try {
      if (!idPersonaResponsable || idPersonaResponsable < 1) {
        alert("Debe seleccionar una Persona Responsable")
        return
      }

      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      if (window.confirm("¿Está seguro de que desea realizar el Cierre de Caja con EFECTIVO $" + saldoCierreEfectivo + ", DÉBITO $" + saldoCierreDebito + " y CRÉDITO $" + saldoCierreCredito + " ?")) {
        await leerEfectivoActual()
        //CALCULO SOBRANTES Y FALTANTES
        let TerminalImporteFaltanteSaldoCierreEfectivo = 0
        let TerminalImporteSobranteSaldoCierreEfectivo = 0

        //FALTANTE
        if (efectivoActual > saldoCierreEfectivo) {
          TerminalImporteFaltanteSaldoCierreEfectivo = efectivoActual - saldoCierreEfectivo
          if (avisaFaltanteAlCierre) {
            if (window.confirm("¿Está seguro que desea generar un faltante de caja de $" + TerminalImporteFaltanteSaldoCierreEfectivo + "?")) {

              const resultFaltante = await function_CON_OperacionesParaImportar_ParaFaltanteCaja_Generar_JSON(true, TerminalImporteFaltanteSaldoCierreEfectivo,
                resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja, idPersonaResponsable)

              await function_CON_OperacionesParaImportar_Insertar(resultFaltante)

            } else {
              throw new Error("El Cierre ha sido cancelado.");
            }
          } else {

            const resultFaltante = await function_CON_OperacionesParaImportar_ParaFaltanteCaja_Generar_JSON(true, TerminalImporteFaltanteSaldoCierreEfectivo,
              resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja, idPersonaResponsable)

            await function_CON_OperacionesParaImportar_Insertar(resultFaltante)
          }
        }

        //SOBRANTE
        if (efectivoActual < saldoCierreEfectivo) {
          TerminalImporteSobranteSaldoCierreEfectivo = saldoCierreEfectivo - efectivoActual

          const resultSobrante = await function_CON_OperacionesParaImportar_ParaSobranteCaja_Generar_JSON(true, TerminalImporteSobranteSaldoCierreEfectivo,
            resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja, idPersonaResponsable)

          await function_CON_OperacionesParaImportar_Insertar(resultSobrante)
        }

        //RETIRO AUTOMATICO AL CIERRE
        if (retiroAutomaticoDelTotalAlCierre) {

          const resultRetiro = await function_CON_Transferencias_Generar_JSON(new Date(),
            resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja,
            resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja, "", "", 0, saldoCierreEfectivo, saldoCierreEfectivo,
            "RETIRO FINAL", "RETIRO FINAL", "", "", "")

          await function_CON_Transferencias_Insertar(resultRetiro)
        }

        const terminalJSON = await function_ABM_IMP_Terminales_ParaCierreDeCaja_Generar_JSON(Terminal, new Date(),
          saldoCierreEfectivo, saldoCierreCredito, saldoCierreDebito)

        const resultPreparacionParaCierre = await function_VEN_CierresDeCaja_Cabecera_PrepararParaCierre(Terminal, resultTerminal.data[0].ImporteUltimoSaldoCierreEfectivo);

        let FaltanteTotalCredito = 0;
        let SobranteTotalCredito = 0;
        let FaltanteTotalDebito = 0;
        let SobranteTotalDebito = 0;

        if (saldoCierreCredito > resultPreparacionParaCierre.data.VentasTotalTarjetasCredito) {
          SobranteTotalCredito = saldoCierreCredito - resultPreparacionParaCierre.data.VentasTotalTarjetasCredito;
        }

        if (saldoCierreCredito < resultPreparacionParaCierre.data.VentasTotalTarjetasCredito) {
          FaltanteTotalCredito = resultPreparacionParaCierre.data.VentasTotalTarjetasCredito - saldoCierreCredito;
        }

        if (saldoCierreDebito > resultPreparacionParaCierre.data.VentasTotalTarjetasDebito) {
          SobranteTotalDebito = saldoCierreDebito - resultPreparacionParaCierre.data.VentasTotalTarjetasDebito;
        }

        if (saldoCierreDebito < resultPreparacionParaCierre.data.VentasTotalTarjetasDebito) {
          FaltanteTotalDebito = resultPreparacionParaCierre.data.VentasTotalTarjetasDebito - saldoCierreDebito;
        }

        resultPreparacionParaCierre.data.CodigoCompania = localStorage.getItem("CodigoCompania");
        resultPreparacionParaCierre.data.CodigoEmpresa = localStorage.getItem("CodigoEmpresa");
        resultPreparacionParaCierre.data.CodigoPlanta = localStorage.getItem("CodigoPlanta");
        resultPreparacionParaCierre.data.FaltanteTotal = TerminalImporteFaltanteSaldoCierreEfectivo;
        resultPreparacionParaCierre.data.SobranteTotal = TerminalImporteSobranteSaldoCierreEfectivo;
        resultPreparacionParaCierre.data.IdPersonaResponsable = idPersonaResponsable;
        resultPreparacionParaCierre.data.Turno = resultTerminal.data[0].UltimoTurnoAbierto;
        resultPreparacionParaCierre.data.FechaApertura = FormateoFechaPara_yyyyMMdd_HHmmss(new Date(resultTerminal.data[0].FechaUltimaCargaSaldoApertura));
        resultPreparacionParaCierre.data.FaltanteTotalApertura = resultTerminal.data[0].ImporteFaltanteSaldoAperturaEfectivo;
        resultPreparacionParaCierre.data.SobranteTotalApertura = resultTerminal.data[0].ImporteSobranteSaldoAperturaEfectivo;
        resultPreparacionParaCierre.data.FaltanteTotalCredito = FaltanteTotalCredito;
        resultPreparacionParaCierre.data.SobranteTotalCredito = SobranteTotalCredito;
        resultPreparacionParaCierre.data.FaltanteTotalDebito = FaltanteTotalDebito;
        resultPreparacionParaCierre.data.SobranteTotalDebito = SobranteTotalDebito;
        resultPreparacionParaCierre.data.SaldoFinalEfectivoDiaAnterior = resultPreparacionParaCierre.data.I_TotalEfectivoCierreAnteriorNoUsarComoDato;
        resultPreparacionParaCierre.data.SaldoFinalEfectivo = saldoCierreEfectivo;

        await function_ABM_IMP_Terminales_Modificar(terminalJSON)
        setResultTerminal(await function_ABM_IMP_Terminales_Leer(Terminal))

        const resultCierreDeCaja = await function_VEN_CierresDeCaja_Cabecera_Insertar(resultPreparacionParaCierre.data)

        localStorage.setItem("ultimoCierreCajaGenerado", resultCierreDeCaja.data.codigoGenerado);

        await function_VEN_CierresDeCaja_Cabecera_ImpresionComandera(resultCierreDeCaja.data.codigoGenerado)


        /*
                
                      Invoke(new Action(() =>
                      {
                          #region Envio de Reporte Articulos CF
        
                          string NombreReporte = "";
        
                          if (Lib_Publicos.Decisiones.SegunCompania() === "307")
                          {
                              Lib_Neftis_Ventas_Complejos.CierreDeCaja CCaja = Lib_Neftis_Ventas_Complejos.CierreDeCaja.Leer(IdCierreDeCaja);
                              Lib_Neftis_Ventas.ImpresorasComanderas.Tickets.ImprimirTicketCierre(CCaja);
                          }
        
                          Rep_General.Ventas.Ventas.CierresDeCaja.frmCierredeCajaTotalesCF_ArticulosPrint CierreCaja3 = new Rep_General.Ventas.Ventas.CierresDeCaja.frmCierredeCajaTotalesCF_ArticulosPrint(IdCierreDeCaja, true);
                          CierreCaja3.WindowState = FormWindowState.Maximized;
                          CierreCaja3.Show();
                          NombreReporte = CierreCaja3.NombreReporte;
        
                          try
                          {
                              #region Try de Envios de Correos
        
                              #region Envio para mi
                              //if (Lib_Utils.Mail.EnviarMailReporte(NombreReporte, "sebastian@latitudvirtual.com.ar", "Terminal: " + resultTerminal.data[0].Descripcion + " - Fecha: " + Obj.CierreDeCajaCab.FechaApertura.ToShortDateString() + " - Caja Nº" + IdCierreDeCaja + " - Turno: " + Obj.CierreDeCajaCab.Turno, "Buen día! Este es el reporte de Cierre de Caja. IMPORTANTE: No respondas este correo ya que es un envío automático de Neftis."))
                              //{
                              //    //Lib_Controles_Complejos.Complejos.LVMensajes.Mensaje("", 1, "Se ha enviado el Reporte.");
                              //}
                              #endregion
        
                              #region Envio General
                              Microsoft.SqlServer.Management.Controls.SortableBindingList<Lib_Neftis_Maestros.ABM_EEX_Personas> Pers = Lib_Neftis_Maestros.ABM_EEX_Personas.Listar(" AND HabilitadoRecepcionMail = 1 AND ISNULL(Email, '') <> '' AND (ABM_EEX_Personas.MultiPlanta = 1 OR ABM_EEXZonasPlantas_Personas.ABM_ZON_Plantas_CodigoPlanta = '" + Lib_Publicos.Declaraciones.GlobalPlanta + "') ");
                              foreach (Lib_Neftis_Maestros.ABM_EEX_Personas PerGer in Pers)
                              {
                                  if (Lib_Utils.Mail.EnviarMailReporte(NombreReporte, PerGer.Email, Lib_Publicos.Declaraciones.GlobalPlanta + " Terminal: " + resultTerminal.data[0].Descripcion + " - Fecha: " + Obj.CierreDeCajaCab.FechaApertura.ToShortDateString() + " - Caja Nº" + IdCierreDeCaja + " - Turno: " + Obj.CierreDeCajaCab.Turno, "Buen día! Este es el reporte de Cierre de Caja. IMPORTANTE: No respondas este correo ya que es un envío automático de Neftis."))
                                  {
                                      //Lib_Controles_Complejos.Complejos.LVMensajes.Mensaje("", 1, "Se ha enviado el Reporte.");
                                  }
                              }
                              #endregion
        
                              #endregion
                          }
                          catch (error)
                          {
        
                          }
        
                          #endregion
        
                          this.Close();
                      }));
              }
              */



        alert("Se ha generado el Cierre de Caja");
        navigate(`/VEN_PuntoDeVenta_`)

      }
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  const handleOnClickImprimirUltimoComprobante = async () => {
    try {
      await function_VEN_DocsVenta_Cabecera_ImpresionComandera(localStorage.getItem("ultimoDocVentaGenerado"))
    } catch (error) {
      alert("Error: " + error)
    }
  }

  const handleOnClickImprimirUltimoCierreDeCaja = async () => {
    try {
      await function_VEN_CierresDeCaja_Cabecera_ImpresionComandera(localStorage.getItem("ultimoCierreCajaGenerado"))
    } catch (error) {
      alert("Error: " + error)
    }
  }

  const handleOnClickAgregarGasto = async () => {
    try {
      if (!idPersonaResponsable || idPersonaResponsable < 1) {
        alert("Debe seleccionar una Persona Responsable")
        return
      }

      if (!idPersonaGastoAutorizante || idPersonaGastoAutorizante < 1) {
        alert("Debe seleccionar una Persona que autorice el Gasto")
        return
      }

      const resultPersonaAutorizante = await function_ABM_EEX_Personas_Leer(idPersonaGastoAutorizante)
      if (passwordGasto !== resultPersonaAutorizante.data.Password) {
        alert("Contraseña inválida.")
        return
      }

      const resultGasto = await function_CON_OperacionesParaImportar_ParaGasto_Generar_JSON(importeGasto, descripcionGasto,
        codigoArticuloGasto, idPersonaResponsable, idPersonaGastoAutorizante,
        resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja)

      await function_CON_OperacionesParaImportar_Insertar(resultGasto)

      await leerEfectivoActual()

      alert("Se ha generado el Gasto");
      navigate(`/VEN_PuntoDeVenta_`)
    } catch (error) {
      alert(error)
    }
  };

  const handleOnClickAgregarRetiro = async () => {
    try {
      if (!idPersonaResponsable || idPersonaResponsable < 1) {
        alert("Debe seleccionar una Persona Responsable")
        return
      }

      if (!idPersonaRetiroAutorizante || idPersonaRetiroAutorizante < 1) {
        alert("Debe seleccionar una Persona que autorice el Retiro")
        return
      }

      const resultPersonaAutorizante = await function_ABM_EEX_Personas_Leer(idPersonaRetiroAutorizante)
      if (passwordRetiro !== resultPersonaAutorizante.data.Password) {
        alert("Contraseña inválida.")
        return
      }

      const resultRetiro = await function_CON_Transferencias_Generar_JSON(FormateoFechaPara_yyyyMMdd(new Date()),
        resultTerminal.data[0].CodigoCuentaFinancieraEfectivoCaja,
        resultTerminal.data[0].CodigoCuentaFinancieraEfectivoRetiros, "", "", 0,
        importeRetiro, importeRetiro, "RETIRO", "RETIRO", "", "", "")

      await function_CON_Transferencias_Insertar(resultRetiro)

      await leerEfectivoActual()

      alert("Se ha generado el Retiro");
      navigate(`/VEN_PuntoDeVenta_`)
    } catch (error) {
      alert(error)
    }
  };

  const verificarFacturasSinValidar = async () => {
    try {
      const resultFacturasSinValidar = await function_VEN_DocsVenta_Cabecera_ListarPorValidarSinCierreDeCajaPorTerminalSeleccionada(Terminal)
      if (resultFacturasSinValidar?.data?.length > 0) {
        setVisualizarWarningDeValidacion(true)
      }
    } catch (e) {
      console.error("Error validando facturas", e)
    }
  }

  useEffect(() => {
    try {
      if (localStorage.getItem("IdPersona") == -1 || localStorage.getItem("IdPersona") == -2 || localStorage.getItem("IdPersona") == -3 || localStorage.getItem("IdPersona") == -4) {
        setPuedeVerSaldosDeCierre(true)
      }

      if (localStorage.getItem("CodigoCompania") === "307") {
        setRetiroAutomaticoDelTotalAlCierre(true)
      }

      if (localStorage.getItem("CodigoCompania") === "SAI" || localStorage.getItem("CodigoCompania") === "SAL") {
        setAvisaFaltanteAlCierre(true)
      }

      //CHEQUEO DE TERMINAL    
      if (!Terminal || Terminal < 1) {
        navigate(`/VEN_PuntoDeVenta_`)
      } else {
        (async () => {
          //LECTURA DE TERMINAL
          setResultTerminal(await function_ABM_IMP_Terminales_Leer(Terminal))

          const datosModificadores = await ObtieneParametros();

          setVentasPVPermiteVisualizarEfectivoDeCaja(await TratamientoDeVariableBoolean(datosModificadores.VentasPVPermiteVisualizarEfectivoDeCaja))
        })();
      }
    } catch (error) {
      alert(error)
    }
  }, []);

  useEffect(() => {
    try {
      //CHEQUEO DE TERMINAL    
      if (!Terminal || Terminal < 1) {
        navigate(`/VEN_PuntoDeVenta_`)
      } else {
        if (resultTerminal && resultTerminal.data) {

          (async () => {
            await leerEfectivoActual();
          })();

          //CONTROL DE APERTURA O CIERRE
          if (resultTerminal.data[0].FechaUltimaCargaSaldoApertura < resultTerminal.data[0].FechaUltimaCargaSaldoCierre) {
            //VISUALIZAR CONTROLES DE APERTURA
            setEsApertura(true)
          }
          else {
            //VISUALIZAR CONTROLES DE CIERRE
            setEsApertura(false)
            
            verificarFacturasSinValidar()

            if (resultTerminal.data[0].IdPersonaUltimaApertura && resultTerminal.data[0].IdPersonaUltimaApertura > 0) {
              setIdPersonaResponsable(resultTerminal.data[0].IdPersonaUltimaApertura)
            }
          }
        }
      }
    } catch (error) {
      alert(error)
    }
  }, [resultTerminal]);

  return (
    <PaginaCarga>
      <div id="Personas" className="LV-GroupBox-div LV-FlexContainer" style={{ marginBottom: "60px" }} >
        Responsable: <ComboAbmEexPersonas value={idPersonaResponsable} onValueChanged={(e) => setIdPersonaResponsable(e.value)} readOnly={!esApertura} />
        Contraseña: <TextBox mode="password" value={passwordApertura} onValueChanged={(e) => setPasswordApertura(e.value)} visible={esApertura} width={200} />
        Efectivo Actual: <NumberBox value={ventasPVPermiteVisualizarEfectivoDeCaja ? efectivoActual : ""} readOnly={true} visible={ventasPVPermiteVisualizarEfectivoDeCaja} />
      </div>

      {!esApertura && (

        <div id="Gastos" className="LV-GroupBox-div LV-FlexContainer" style={{ marginBottom: "20px" }} >
          <span style={{ fontWeight: 'bold', marginRight: '10px' }}>GASTOS</span>
          Importe: <NumberBox value={importeGasto} onValueChanged={(e) => setImporteGasto(e.value)} width={100} />
          Artículo: <ComboAbmArtArticulosGastosPV value={codigoArticuloGasto} onValueChanged={(e) => setCodigoArticuloGasto(e.value)} ancho={400} />
          Descripción: <TextBox value={descripcionGasto} onValueChanged={(e) => setDescripcionGasto(e.value)} width={200} />
          Autoriza: <ComboAbmEexPersonasAutorizantes
            value={idPersonaGastoAutorizante}
            onValueChanged={(e) => setIdPersonaGastoAutorizante(e.value)}
            PuedeAutorizarGastos={true} />
          Contraseña: <TextBox mode="password" value={passwordGasto} onValueChanged={(e) => setPasswordGasto(e.value)} width={200} />
          <LVButtonAccion onClick={handleOnClickAgregarGasto} Texto="GENERAR" Ancho={150} />
        </div>
      )}

      {!esApertura && (
        <div id="Retiros" className="LV-GroupBox-div LV-FlexContainer" style={{ marginBottom: "20px" }} >
          <span style={{ fontWeight: 'bold', marginRight: '10px' }}>RETIROS</span>
          Importe: <NumberBox value={importeRetiro} onValueChanged={(e) => setImporteRetiro(e.value)} width={100} />
          Autoriza: <ComboAbmEexPersonasAutorizantes
            value={idPersonaRetiroAutorizante}
            onValueChanged={(e) => setIdPersonaRetiroAutorizante(e.value)}
            PuedeRetirarDinero={true} />
          Contraseña: <TextBox mode="password" value={passwordRetiro} onValueChanged={(e) => setPasswordRetiro(e.value)} width={200} />
          <LVButtonAccion onClick={handleOnClickAgregarRetiro} Texto="GENERAR" Ancho={150} />
        </div>
      )}

      {esApertura && (
        <div id="Apertura" className="LV-GroupBox-div LV-FlexContainer" style={{ marginBottom: "20px" }} >
          <span style={{ fontWeight: 'bold', marginRight: '10px' }}>APERTURA DE CAJA</span>
          Efectivo: <NumberBox value={saldoAperturaEfectivo} onValueChanged={(e) => setSaldoAperturaEfectivo(e.value)} width={100} />
          {puedeVerSaldosDeCierre && (
            <>
              Faltante Ef.: <NumberBox value={Math.max(0, efectivoActual - saldoAperturaEfectivo)} readOnly={true} width={100} />
              Sobrante Ef.: <NumberBox value={Math.max(0, saldoAperturaEfectivo - efectivoActual)} readOnly={true} width={100} />
            </>
          )}
          <LVButtonAccion
            Disabled={cierreEnProceso} onClick={handleOnClickAceptarApertura} Texto="ABRIR CAJA" Ancho={150} />
        </div>
      )}

      {!esApertura && (
        <div id="Cierre" className="LV-GroupBox-div LV-FlexContainer" style={{ marginBottom: "20px" }} >
          <span style={{ fontWeight: 'bold', marginRight: '10px' }}>CIERRE DE CAJA</span>
          Efectivo: <NumberBox value={saldoCierreEfectivo} onValueChanged={(e) => setSaldoCierreEfectivo(e.value)} width={100} />
          Crédito: <NumberBox value={saldoCierreCredito} onValueChanged={(e) => setSaldoCierreCredito(e.value)} width={100} />
          Débito: <NumberBox value={saldoCierreDebito} onValueChanged={(e) => setSaldoCierreDebito(e.value)} width={100} />
          <LVButtonAccion
            Disabled={cierreEnProceso} onClick={handleOnClickAceptarCierre} Texto="CERRAR CAJA" Ancho={150} />

          {puedeVerSaldosDeCierre && (
            <>
              Faltante Ef.: <NumberBox value={Math.max(0, efectivoActual - saldoCierreEfectivo)} readOnly={true} width={100} />
              Sobrante Ef.: <NumberBox value={Math.max(0, saldoCierreEfectivo - efectivoActual)} readOnly={true} width={100} />
            </>
          )}

          {resultTerminal.data && resultTerminal.data.length > 0 ? (
            puedeVerSaldosDeCierre && (
              <>
                Ult. Cierre Ef.: <NumberBox value={resultTerminal.data[0].ImporteUltimoSaldoCierreEfectivo} readOnly={true} width={100} visible={puedeVerSaldosDeCierre} />
                Ult. Cierre Cr.: <NumberBox value={resultTerminal.data[0].ImporteUltimoSaldoCierreCredito} readOnly={true} width={100} visible={puedeVerSaldosDeCierre} />
                Ult. Cierre De.: <NumberBox value={resultTerminal.data[0].ImporteUltimoSaldoCierreDebito} readOnly={true} width={100} visible={puedeVerSaldosDeCierre} />
                Ult. Apert. Ef.: <NumberBox value={resultTerminal.data[0].ImporteUltimoSaldoAperturaEfectivo} readOnly={true} width={100} visible={puedeVerSaldosDeCierre} />
                Ult. Apert. Fal.: <NumberBox value={resultTerminal.data[0].ImporteFaltanteSaldoAperturaEfectivo} readOnly={true} width={100} visible={puedeVerSaldosDeCierre} />
                Ult. Apert. Sob.: <NumberBox value={resultTerminal.data[0].ImporteSobranteSaldoAperturaEfectivo} readOnly={true} width={100} visible={puedeVerSaldosDeCierre} />
              </>
            )
          ) : (
            <p>Cargando datos...</p> // O algún mensaje alternativo mientras no llegan los datos
          )}
        </div>
      )}

      <div
        id="Impresion"
        className="LV-GroupBox-div LV-FlexContainer"
        style={{
          marginBottom: "20px",
          gap: "15px",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <div style={{ display: "flex", gap: "15px" }}>
          <LVButtonAccion
            onClick={handleOnClickImprimirUltimoComprobante}
            Texto="IMPRIMIR ÚLTIMO COMPROBANTE"
            Ancho={300}
          />
          <LVButtonAccion
            onClick={handleOnClickImprimirUltimoCierreDeCaja}
            Texto="IMPRIMIR ÚLTIMO CIERRE DE CAJA"
            Ancho={350}
          />
        </div>

        {visualizarWarningDeValidacion && (
          <div
            style={{
              backgroundColor: "red",
              border: "1px solid red",
              color: "yellow",
              padding: "10px 15px",
              borderRadius: "4px",
              fontWeight: "bold",
              maxWidth: "350px",
              textAlign: "right"
            }}
          >
            ⚠️ Hay comprobantes sin validar.
          </div>
        )}
      </div>

      <LVButtonAccion onClick={() => navigate(`/VEN_PuntoDeVenta_`)} Texto="REGRESAR AL PUNTO DE VENTA" Ancho={"100%"} />
    </PaginaCarga>
  );
};
